import { render, staticRenderFns } from "./Pettycash.vue?vue&type=template&id=c920a54e&"
import script from "./Pettycash.vue?vue&type=script&lang=js&"
export * from "./Pettycash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports